import ReactLogo from '../assets/images/logo.svg';
import { GetSlogan } from './Slogan';
import { useSelector } from 'react-redux';

export const WelcomeMessage = () => {
  const hasCards = useSelector(state => state.cards.cards.length > 0);
  return (
    !hasCards && (
      <div
        className="c1 p-4 flex flex-col items-center justify-center text-2xl h-screen"
      >
        <img src={ReactLogo} className="h-32 m-8" />
        <h3>Welcome to iCare</h3>
        <GetSlogan />
      </div>
    )
  )
}